import React from "react";

const Catalogoto = () => {
    return (
        <>
            <div style={{ height: "100vh"}}>
                <iframe 
                    src="/PDF/catalogo-togas-mr.pdf"
                    width="100%"
                    height="100%"
                    style={{ border: "none"}}
                    title="Catálogo de Togas"
                />
            </div>
        </>
    );
};

export default Catalogoto;